import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext();

const THEMES = {
  true: 'dark',
  false: 'light',
}

export function ThemeProvider({ children }) {
  const defaultValue = useMemo(() => {
    const userPreference = localStorage.getItem('theme')

    if (userPreference) {
      return userPreference === 'dark'
    }

    const darkSystem = window?.matchMedia('(prefers-color-scheme: dark)')

    if (darkSystem) {
      darkSystem.addEventListener('change', e => {
        setToggle(!!e.matches)
      })

      return !!darkSystem.matches
    }
    return false
  }, [])

  const [toggle, setToggle] = useState(defaultValue);
  const theme = THEMES[toggle]

  useEffect(() => {
    document.documentElement.classList.toggle('dark', toggle);
    return () => {
      document.documentElement.classList.remove('dark');
    };
  }, [toggle]);

  return <ThemeContext.Provider value={useMemo(() => ({ setToggle, theme }), [theme])}>
    <div className={`${theme} scrollbar`} id='theme-provider'>
      {children}
    </div>
  </ThemeContext.Provider>
}

export const useThemeToggle = () => {
  const { setToggle } = useContext(ThemeContext)
  return useCallback(() => setToggle(toggle => {
    const userPreference = !toggle
    localStorage.setItem('theme', userPreference ? 'dark' : 'light')
    return userPreference
  }), [setToggle])
};

export const useTheme = () => {
  const { theme } = useContext(ThemeContext)
  return theme
}
